<template>
  <Menu as="div" class="relative">
    <MenuButton class="group flex gap-1 text-menu-link items-center">
      <PaintBrushIcon class="w-5 group-hover:scale-105 transition" /><span class="hidden lg:block text-base">{{
        shopName
      }}</span
      ><ChevronDownIcon class="size-3 flex-none"
    /></MenuButton>
    <MenuItems
      as="div"
      class="flex flex-col absolute right-0 z-20 mt-3 origin-top-right rounded-md bg-surface text-foreground shadow-lg ring-1 ring-black/5 overflow-hidden focus:outline-none">
      <MenuItem
        v-for="shop in b2shops"
        class="px-4 py-1 whitespace-nowrap text-left hover:bg-gray-100 hover:text-black"
        as="button"
        @click="setShop(shop.key)"
        >{{ shop.text }} <span v-if="shop.key == selectedShop">({{ $t("Selected") }})</span></MenuItem
      >
    </MenuItems>
  </Menu>
</template>

<script setup lang="ts">
import { b2shops } from "@/brandconfig";
import { useLocalStorage } from "@vueuse/core";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronDownIcon, PaintBrushIcon } from "@heroicons/vue/24/outline";
import { computed } from "vue";

const selectedShop = useLocalStorage("b2c_override", "xs2event");

const shopName = computed(() => b2shops.find((x) => x.key == selectedShop.value)!.text);

const setShop = (key: string) => {
  selectedShop.value = key;
  window.location.reload();
};
</script>
